import * as React from "react";
const SvgMenu = (props) => (React.createElement("svg", Object.assign({ viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9 4.008v3h6v-6H9v3ZM9 12v3h6V9H9v3Zm0 7.992v3h6v-6H9v3Z", fill: "currentColor" })));
export default SvgMenu;
